import React from 'react';
import {FormattedMessage} from "react-intl";

const OrderType3View = (props) => {
    let frameworkValue = props.smtStencilParams.framework;
    let dimensionValue = props.smtStencilParams.dimensionsID;
    let stencilSideValue = props.smtStencilParams.stencilSide;
    let electroPolishingValue = props.smtStencilParams.electropolishing;
    let fiducialsValue = props.smtStencilParams.fiducials;


    // let buildTime = props.itemDetails.chargeDetails.buildTime !== "" ? props.itemDetails.chargeDetails.buildTime+" days" : '';


    let framework = frameworkValue === 1 ? <FormattedMessage id="app.stencil-quotation.stencil-framework-yes"
                                                             defaultMessage="Yes" description=""/> :
        frameworkValue === 0 ? <FormattedMessage id="app.stencil-quotation.stencil-framework-no"
                                                 defaultMessage="No" description=""/> : "";

    let dimensions="380×280（有効エリア290×190mm)";
    if(props.smtStencilParams.framework===0){
        dimensions = dimensionValue === 112 ? "380×280（有効エリア290×190mm)" :
            dimensionValue === 501 ?  "420×320（有効エリア400×240mm":
                dimensionValue === 502 ? "450×350（有効エリア420×270mm" :
                    dimensionValue === 503 ? "520×420（有効エリア490×340mm" :
                        dimensionValue === 504 ? "460×460（有効エリア430×380mm" : '';

    } else {

        dimensions = dimensionValue === 2 ? "470×370（有効エリア290×190mm" :
            dimensionValue === 111 ?  "400×300（有効エリア240×140mm":
                dimensionValue === 3 ? "520×420（有効エリア340×240mm" :
                    dimensionValue === 6 ? "550×450（有効エリア370×270mm" :
                        dimensionValue === 7 ? "584×584（有効エリア380×380mm" :
                            dimensionValue === 5 ? "650×550（有効エリア450×350mm" :
                                dimensionValue === 124 ? "700×500（有効エリア500×320mm" :
                                    dimensionValue === 108 ? "600×400（有効エリア400×220mm" :
                                        dimensionValue === 8 ? "736×736（有効エリア500×500mm" :
                                            dimensionValue === 3 ? "520×420（有効エリア340×240mm" :
                                                dimensionValue === 109 ? "800×400（有効エリア600×220mm" :
                                                    dimensionValue === 114 ? "800×500（有効エリア600×320mm" :
                                                        dimensionValue === 110 ? "1000×400（有効エリア760×220mm" : '';
    }
   /* let dimensions = dimensionValue === "380*280" ? "380*280(Valid area 290mm*190mm, $6.03, 0.8kg)" :
        dimensionValue === "100*100" ? "100*100(default dimension)" : "";*/


    let stencilSideVal = stencilSideValue === 0 ? <FormattedMessage id="app.stencil-quotation.stencil-side-1"
                                                                    defaultMessage="Top+Bottom(On Single Stencil)"
                                                                    description=""/> :
        stencilSideValue === 1 ? <FormattedMessage id="app.stencil-quotation.stencil-side-2"
                                                   defaultMessage="Top"
                                                   description=""/> :
            stencilSideValue === 2 ? <FormattedMessage id="app.stencil-quotation.stencil-side-3"
                                                       defaultMessage="Bottom"
                                                       description=""/> :
                stencilSideValue === 3 ? <FormattedMessage id="app.stencil-quotation.stencil-side-4"
                                                           defaultMessage="Top+Bottom(On Separate Stencil)"
                                                           description=""/> : "";


    let electroPolishingVal =  electroPolishingValue === 1 ?  <FormattedMessage id="app.stencil-quotation.stencil-electropolishing-yes"
                                                                                defaultMessage="Yes"
                                                                                description=""/> :
        electroPolishingValue === 0 ? <FormattedMessage id="app.stencil-quotation.stencil-electropolishing-no"
                                                        defaultMessage="No"
                                                        description=""/> : "";

    let fiducialVal = fiducialsValue === 0 ? <FormattedMessage id="app.stencil-quotation.stencil-fiducials-1"
                                                               defaultMessage="No Fiducial"
                                                               description=""/> :
        fiducialsValue === 1 ? <FormattedMessage id="app.stencil-quotation.stencil-fiducials-2"
                                                 defaultMessage="Etched Through"
                                                 description=""/> :
            fiducialsValue === 2 ? <FormattedMessage id="app.stencil-quotation.stencil-fiducials-3"
                                                     defaultMessage="Etched Half Into Board"
                                                     description=""/> : "";

    return (

        <div className="cart-item-detail">
            <div className="cart-item-detail-header">
                {/*<div className="item-details">Stencil Order Details</div>*/}
            </div>
            <div>
                <div>
                    <small>
                        <div className="title-1 text-align-l details-modal-style">
                            <FormattedMessage id="app.quotation.summary.title.metal-mask"
                                              defaultMessage="METAL MASK MANUFACTURING SPECIFICATION"
                                              description=""/>
                        </div>
                        <div>
                        <span className="order-item-detail-span">
                               <FormattedMessage id="app.order.expanded.file"
                                                 defaultMessage="Gerber File"
                                                 description=""/> : &nbsp;
                        </span>
                            <span className="pcb-data-span">
                                {props.itemDetails.itemName}
                            </span>
                            <br/>
                        </div>
                        {/*<div>
                        <span className="cart-item-detail-span">
                              <FormattedMessage id="app.order.expanded.build-time"
                                                defaultMessage="Build Time"
                                                description=""/> : &nbsp;
                        </span>
                            {buildTime}<br/>
                        </div>*/}
                        <div>
                        <span className="order-item-detail-span">
                            <FormattedMessage id="app.order.expanded.framework"
                                              defaultMessage="Framework"
                                              description=""/>
                               : &nbsp;
                        </span>
                            <span className="pcb-data-span">
                                {framework}
                            </span>
                            <br/>
                        </div>
                        <div>
                        <span className="order-item-detail-span">
                              <FormattedMessage id="app.order.expanded.dimensions"
                                                defaultMessage="Dimensions"
                                                description=""/> : &nbsp;
                        </span>
                            <span className="pcb-data-span">
                                {dimensions}
                                {/*{dimensionValue}*/}
                            </span>
                            <br/>
                        </div>
                        <div>
                        <span className="order-item-detail-span">
                            <FormattedMessage id="app.order.expanded.electro-polishing"
                                              defaultMessage="Electro Polishing"
                                              description=""/>
                               : &nbsp;
                        </span>
                            <span className="pcb-data-span">
                                {electroPolishingVal}
                            </span>
                            <br/>
                        </div>
                        <div>
                        <span className="order-item-detail-span">
                            <FormattedMessage id="app.order.expanded.fiducials"
                                              defaultMessage="Fiducials"
                                              description=""/>
                               : &nbsp;
                        </span>
                            <span className="pcb-data-span">
                                {fiducialVal}
                            </span>
                            <br/>
                        </div>
                        <div>
                        <span className="order-item-detail-span">
                            <FormattedMessage id="app.order.expanded.flag"
                                              defaultMessage="Customize Flag"
                                              description=""/>
                               : &nbsp;
                        </span>
                            <span className="pcb-data-span">
                                 {props.smtStencilParams.customizeFlag}
                            </span>
                           <br/>
                        </div>
                        <div>
                        <span className="order-item-detail-span">
                            <FormattedMessage id="app.order.expanded.cusomize-size"
                                              defaultMessage="Customize Size (X/Y)"
                                              description=""/>
                               : &nbsp;
                        </span>
                            <span className="pcb-data-span">
                                {""+props.smtStencilParams.customizeSizeX+" mm X "+props.smtStencilParams.customizeSizeY+" mm"}
                            </span>
                           <br/>
                        </div>
                        <div>
                        <span className="order-item-detail-span">
                            <FormattedMessage id="app.order.expanded.stencil-side"
                                              defaultMessage="Stencil Side"
                                              description=""/>
                               : &nbsp;
                        </span>
                            <span className="pcb-data-span">
                                {stencilSideVal}
                            </span>
                            <br/>
                        </div>
                        <div>
                            <span className="order-item-detail-span">
                                <FormattedMessage id="app.order.expanded.remarks"
                                                           defaultMessage="Order Remarks"
                                                           description=""/>
                                         : &nbsp;</span>
                            <span className="pcb-data-span">
                                 {props.smtStencilParams.orderRemark==="" || props.smtStencilParams.orderRemark===null ?
                                     <text><FormattedMessage id="app.order.expanded.no-remarks"
                                                             defaultMessage="No Remarks"
                                                             description=""/></text>:<text>{props.smtStencilParams.orderRemark}</text>
                                 }

                            </span>
                            <br/>
                        </div>
                    </small>
                </div>
            </div>
        </div>
    )
};
export default OrderType3View;



// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderHistory/OrderItem/OrderTypeView/OrderType3View.js